export enum EnumExpenseTypes {
    Revenue = 'Receitas',
    Operating_Expenses = 'Despesas Operacionais',
    Administrative_Expenses = 'Despesas Administrativas',
    Marketing_Commercial = 'Marketing e Comercial',
    Maintenance_Infrastructure = 'Manutenção e Infraestrutura',
    Variable_Expenses = 'Despesas Variáveis',
    Results_Investments = 'Resultados e Investimentos'
}

export const expenseTypes = Object.entries(EnumExpenseTypes).map(([key, value]) => ({ value: key, label: value }));
